import React from 'react';
import { formatPhoneNumber } from '../../utils/formatters';

interface ClientDisplayProps {
  clientName: string;
  locationName?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  contactPhone?: string;
  contactEmail?: string;
  className?: string;
}

const ClientDisplay: React.FC<ClientDisplayProps> = ({
  clientName,
  locationName,
  streetAddress,
  city,
  state,
  zipCode,
  contactPhone,
  contactEmail,
  className = "text-sm"
}) => {
  return (
    <div className={className}>
      {/* Client Name */}
      <div className="font-medium text-gray-900 dark:text-gray-100 mb-1">
        {clientName}
      </div>

      {/* Location Name (pin) */}
      {locationName && locationName.trim() && (
        <div className="text-xs text-gray-600 dark:text-gray-300 font-medium">
          📍 {locationName.replace(' - Primary Location', '').trim()}
        </div>
      )}

      {/* Street Address */}
      {streetAddress && streetAddress.trim() && (
        <div className="text-xs text-gray-500 dark:text-gray-400">
          <div className="flex items-center">
            <span className="mr-1">🏠</span>
            <span>{streetAddress}</span>
          </div>
        </div>
      )}

      {/* City, State Zip */}
      {(city || state || zipCode) && (
        <div className="text-xs text-gray-500 dark:text-gray-400">
          <div className="flex items-center">
            <span className="mr-1">📍</span>
            <span>
              {city ? city : ''}
              {city && state ? ', ' : ''}
              {state ? state : ''}
              {zipCode ? ` ${zipCode}` : ''}
            </span>
          </div>
        </div>
      )}

      {/* Contact Information */}
      {contactPhone && (
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          <div className="flex items-center">
            <span className="mr-1">📞</span>
            {formatPhoneNumber(contactPhone)}
          </div>
        </div>
      )}
      {contactEmail && (
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          <div className="flex items-center">
            <span className="mr-1">✉️</span>
            {contactEmail}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientDisplay;
